import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../services/error.service';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { loadMessages, locale } from 'devextreme/localization';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';

import { first } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Ads, AdsService } from '../services/ads.service';
import { LoginUser, PatientDataViewModel, RolesFunc, TaskSablon } from '../services/webapiclient.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { convertBlobToBase64 } from '../shared/utils';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog-service';
import { PatientService } from '../module-patient/patient.service';
import { AuthenticationService } from '../services/authentication.service';
import { CodesFunc, CodeWarehouseEditModel } from '../services/codes.service';

/**
 * Háziorvosi automata feladatkiírások összeállítása.
 */

@Component({
    selector: 'app-task-sablon',
    templateUrl: './task-sablon.component.html',
    styleUrl: './task-sablon.component.scss',
    standalone: false
})

export class TaskSablonComponent implements OnInit, OnDestroy {
  @ViewChild('editFormtmpl', { static: true }) editFormtmpl: TemplateRef<any>;

  modalRef: BsModalRef;

  stylingMode = "filled"
  dateFormat: string;

  options: any[];
  option: number;
  selectedOption: any;

  error: any;
  private translSubs$: Subscription;

  loading: boolean = false;
  addNew: boolean = false;
  selectedIndex: number;
  patientDataViewModel: PatientDataViewModel = {} as PatientDataViewModel;
  taskSablonList: TaskSablon[];
  currentUser: LoginUser;
  editItem: TaskSablon;
  gamesSource: any;
  regularitySource: any;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private patientService: PatientService,
    private adsService: AdsService,
    private authenticationService: AuthenticationService,
    private modalService: BsModalService,
    private codesFunc: CodesFunc,
    private translation: L10nTranslationService,
    private http: HttpClient,
    private confirmDialogService: ConfirmDialogService
  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });
    this.currentUser = this.authenticationService.currentUserValue;

    //Opció választó
    this.options = [
      {
        "name": this.translation.translate('Game.Month'),
        "value": 0
      },
      {
        "name": this.translation.translate('Game.QY'),
        "value": 1
      },
      {
        "name": this.translation.translate('Game.HY'),
        "value": 2
      }
    ];
    this.option = this.options[0].value;
    this.selectedOption = this.options[0];

  }


  ngOnInit(): void {
    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
        this.dateFormat = this.translation.translate('Core.DateFormat');
      });
      this.getPatientData(this.currentUser.id);
      this.loadCodesSources();
  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
  }

  onOptionChanged(days, index) {
    this.selectedOption = this.options[index];
    this.option = index;
    this.getTaskSablon(this.currentUser.id,index);
  }

  //Kódok betöltése
  loadCodesSources() {
    this.codesFunc.getCodesData('TaskFrequency').then(
      result => {
        this.regularitySource = <CodeWarehouseEditModel[]>result;
      }
    ).catch(err => {
      this.error = err;
    });
    this.codesFunc.getCodesData('Games').then(
      result => {
        this.gamesSource = <CodeWarehouseEditModel[]>result;
      }
    ).catch(err => {
      this.error = err;
    });
  }

  getPatientData(id: string) {
    this.loading = true;
    this.patientService.getPatient(id).then(
      result => {
        this.patientDataViewModel = <PatientDataViewModel>result;
        let index = this.patientDataViewModel.taskSablonType ?? 0;
        this.option = this.options[index].value;
        this.selectedOption = this.options[index];
        this.getTaskSablon(id,index);
    
        this.loading = false;
      }
    ).catch(err => {
      this.error = err;
      this.loading = false;
    });
  }

  getTaskSablon(doctorId: string, taskSablonType) {
    this.loading = true;
    this.patientService.getTaskSablon(doctorId,taskSablonType).then(
      result => {
        this.taskSablonList = <TaskSablon[]>result;
        this.loading = false;
      }
    ).catch(err => {
      this.error = err;
      this.loading = false;
    });
  }

  clickNew() {
    this.editItem = <TaskSablon>{};
    //this.editItem.forDoctor = false;
    this.addNew = true;
    this.editItem.doctorId = this.currentUser.id;
    this.modalRef = this.modalService.show(this.editFormtmpl, { class: 'modal-lg', backdrop: 'static', keyboard: false });
  }


  closeModal() {
    this.modalRef.hide();
  }

  clickEdit(index) {
    this.editItem = this.taskSablonList[index];
    this.selectedIndex = index;
    this.addNew = false;
    this.modalRef = this.modalService.show(this.editFormtmpl, { class: 'modal-lg', backdrop: 'static', keyboard: false });
  }

  clickDelete(index) {
    const that = this;
    this.confirmDialogService.confirmThis(this.translation.translate('Core.ConfirmDeleting'), function () {
      if (that.taskSablonList[index].id) {
        that.patientService.deleteTaskSablon(that.currentUser.id, that.taskSablonList[index].id).then(
          result => {
            if (result == "OK") {
              that.taskSablonList.splice(index, 1);
            } else {
              that.error = result;
            }
          }
        ).catch(err => {
          that.error = err;
        });
      }
    }, function () {
      //alert("No clicked");  
    })
  }

  simpleClone(obj: any) {
    return Object.assign({}, obj);
  }

  onFormSubmit = function (e) {
    this.error = "";
    this.loading = true;
    if (!this.addNew) {
      //módosítás
      this.taskSablonList[this.selectedIndex] = this.simpleClone(this.editItem);

      this.patientService.updateTaskSablon(JSON.stringify(this.taskSablonList[this.selectedIndex])).then(
        result => {
          if (result == "OK") {
            this.getTaskSablon(this.currentUser.id, this.option);
            notify({
              message: this.translation.translate('Core.SaveSuccessful'),
              position: {
                my: "center top",
                at: "center top"
              }
            }, "success", 3000);
            this.closeModal();
          } else {
            this.error = result;
            this.loading = false;
          }
        }
      ).catch(err => {
        this.error = err;
        this.loading = false;
      });
    } else {
      //új
      this.patientService.insertTaskSablon(JSON.stringify(this.editItem)).then(
        result => {
          if (!result.error) {
            //console.log(this.editItem);
            notify({
              message: this.translation.translate('Core.SaveSuccessful'),
              position: {
                my: "center top",
                at: "center top"
              }
            }, "success", 3000);
            this.addNew = false;
            this.closeModal();
            this.getTaskSablon(this.currentUser.id, this.option);
          } else {
            this.error = result.error;
            this.loading = false;
          }
        }
      ).catch(err => {
        this.error = err;
        this.loading = false;
      });

    }
    //let result: any;

    if(e) e.preventDefault();
  }

  onShown() {
    setTimeout(() => {
      this.loading = false;
    }, 15000);
  }

}
